import { render, staticRenderFns } from "./AmountDetail.vue?vue&type=template&id=3d774e1a&scoped=true&"
import script from "./AmountDetail.vue?vue&type=script&lang=ts&"
export * from "./AmountDetail.vue?vue&type=script&lang=ts&"
import style0 from "./AmountDetail.vue?vue&type=style&index=0&id=3d774e1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d774e1a",
  null
  
)

export default component.exports